// Build-time override for the API base URL (must include the trailing /api). Lets a deploy
// point at a custom API domain (e.g. api.educationdatacollective.com) without a code change.
// The appspot URLs below remain the fallbacks if it is unset. Other modules that resolve the
// API base (utils/apiConfig.js and the school processor tools) already honor this variable.
const apiUrlOverride = process.env.REACT_APP_API_URL;

const config = {
    development: {
      apiUrl: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
        ? 'http://localhost:5001/api'  // Local backend
        : 'https://enrollment-risk-v2.uc.r.appspot.com/api', // GAE backend
      gaMeasurementId: process.env.REACT_APP_MEASUREMENT_ID || 'G-8RWK33VE4R', // Development GA4
      environment: 'development'
    },
    staging: {
      apiUrl: apiUrlOverride || 'https://enrollment-risk-v2-staging.uc.r.appspot.com/api',
      gaMeasurementId: process.env.REACT_APP_MEASUREMENT_ID || 'G-8RWK33VE4R', // Staging GA4
      environment: 'staging'
    },
    production: {
        apiUrl: apiUrlOverride || 'https://enrollment-risk-v2-production.uc.r.appspot.com/api',
        gaMeasurementId: process.env.REACT_APP_MEASUREMENT_ID || 'G-8RWK33VE4R', // Production GA4
        environment: 'production'
    }
  };
  
  export default config[process.env.REACT_APP_ENV || 'development'];